import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { CompanyData } from '../../../types/company-data';

export abstract class EditCompanyPanelBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getManagedCompanyById(companyId: string): Promise<CompanyData>;
}
